import styled from 'styled-components';

export const Title = styled.header`
  font-size: 1.4rem;

  a {
    text-decoration: none;

    h1 {
      color: var(--primary-color);
    }
  }
`;